import { ApplicationConfig } from '@angular/core';
import { ActivatedRoute, provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient } from '@angular/common/http';
import { INITIAL_CONFIG, initialConfigFactory } from './config/initial-config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(),
    {
      provide: INITIAL_CONFIG,
      useFactory: initialConfigFactory,
      deps: [ActivatedRoute]
    }
  ]
};
